import { Component, ComponentFactoryResolver, ElementRef, Injector, OnInit } from '@angular/core';
import { ComponentBase } from '@abstracts/component-base';
import { UserDto } from '@dto/userDto';
import { UsersService } from '@services/entity/users.service';

@Component({
  selector: 'upvoty-widget',
  templateUrl: './upvoty.component.html',
  styleUrls: ['./upvoty.component.scss'],
})
export class UpvotyComponent extends ComponentBase implements OnInit {

  public className: string
  public isVisible: boolean = true
  private widget: any
  private user: UserDto
  private token: string
  private timeout: any
  private timer: number = 0

  constructor(
    private elementRef: ElementRef,
    private usersService: UsersService,
    injector: Injector
  ) {
    super(injector)
  }

  public ngOnInit(): void {
    if (document.cookie.includes('cookie_consent=all_cookies')) {
      window.onload = () => {
        var script = document.createElement("script")
        script.type = "text/javascript"
        script.src = 'https://cubosconnect.upvoty.com/javascript/upvoty.embed.js'
    
        this.elementRef.nativeElement.appendChild(script)
        this.widget = this.elementRef.nativeElement.children[0]
  
        this.initWidget()
      }
    }
  }
  
  initWidget() {
    if (window['upvoty'] === undefined && this.timer < 5) {
      this.timeout = window.setTimeout(() => {
        this.timer++
        this.initWidget()
      }, 5000)
    } else {
      this.createWidget()
    }
  }

  checkVisibilityForRoute() {
    const path = window.location.pathname
    if (
      path.includes('/public-charge')
      || path.includes('/auth')
    ) {
      return false
    }
    return true
  }

  createWidget() {
    this.isVisible = this.checkVisibilityForRoute()

    if (!this.isVisible) return
    if (!this.authenticationService.isUserAuthenticated()) return

    this.usersService.getLoggedInUser().subscribe(user => {
      this.user = user
      this.usersService.getUpvotyToken(
        'cedb7f13f3d09a3b9316c8c12e140859',
        this.user.id,
        this.user.fullName,
        this.user.email
      ).subscribe(jwt => {
        this.token = jwt.token
        if (window['upvoty']) {
          window['upvoty'].init('render', {
            'boardHash': 'ef8e31bf360f38e1a4b8b4973f2e4c972f1477b572ba89ead4534c41bb5c9aac',
            'ssoToken': this.token,
            'baseUrl': 'cubosconnect.upvoty.com'
          })
          this.fixFrameHeight()
        } else {
          this.isVisible = false
        }
      }, error => {
        this.isVisible = false
      })
    }, error => {
      this.isVisible = false
    })
  }

  toggleAppearance(button) {
    if (button) button.blur()

    this.widget.scrollTo(0, this.widget.offsetHeight)
    this.widget.classList.toggle('show')
  }

  fixFrameHeight() {
    window.setTimeout(() => {
      this.widget.classList.toggle('show')
      window.setTimeout(() => {
        this.widget.removeAttribute('style')
      }, 500)
    }, 1000)
  }
}
